"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactModal = require("react-modal");
require("./modal-full.scss");
var MODAL_STYLES = {
    overlay: { position: "fixed", backgroundColor: "#33333399" },
    content: { position: "relative", top: "50%", transform: "translateY(-50%)", maxHeight: "80%", width: "70%", border: "none", right: 0, left: 0, bottom: 0, borderRadius: 4, margin: "0 auto" },
};
var Modal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, children = _a.children;
    var modalClassName = "full-modal";
    return (React.createElement(ReactModal, { enforceFocus: false, className: modalClassName, closeTimeoutMS: 150, isOpen: isOpen, onRequestClose: onClose, shouldCloseOnOverlayClick: false, style: MODAL_STYLES, contentLabel: "" }, children));
};
exports.default = Modal;
//# sourceMappingURL=modal.js.map